import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b864f94")

_pushScopeId("data-v-3b864f94")
const _hoisted_1 = {
  key: 0,
  class: "mx-4 text-center text-gray-700 dark:text-gray-500 mb-2"
}
const _hoisted_2 = {
  key: 1,
  class: "mx-4 text-center text-gray-700 dark:text-gray-500 mb-2"
}
const _hoisted_3 = { class: "mb-6 md:mb-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_activation_animation = _resolveComponent("activation-animation")
  const _component_error_activation_animation = _resolveComponent("error-activation-animation")
  const _component_DefaultButton = _resolveComponent("DefaultButton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (!$setup.subscribeHasError)
        ? (_openBlock(), _createBlock("h1", _hoisted_1, _toDisplayString(_ctx.$t("modal.SubscribeDialog.thankYouTitle")), 1))
        : (_openBlock(), _createBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t("auth.auth_error_failed_title")), 1)),
      (!$setup.subscribeHasError)
        ? (_openBlock(), _createBlock(_component_activation_animation, { key: 2 }))
        : (_openBlock(), _createBlock(_component_error_activation_animation, { key: 3 }))
    ]),
    _createVNode("div", _hoisted_3, [
      (!$setup.subscribeHasError)
        ? (_openBlock(), _createBlock(_component_DefaultButton, {
            key: 0,
            onClick: _ctx.close,
            "button-text": _ctx.$t('modal.SubscribeDialog.close'),
            "button-color": "bg-bp-light",
            "button-hover": "hover:bg-bp-light",
            "button-width": "w-auto",
            "button-x-margin": "mx-auto",
            "center-button": "mb-6",
            "button-type": "back",
            "custom-css": "disabled:opacity-50 "
          }, null, 8, ["onClick", "button-text"]))
        : ($setup.subscribeHasError && $props.subscriptionData)
          ? (_openBlock(), _createBlock(_component_DefaultButton, {
              key: 1,
              onClick: $setup.retrySubscribeBoostpack,
              "button-text": _ctx.$t('modal.SubscribeDialog.retry'),
              "button-color": "bg-bp-light",
              "button-hover": "hover:bg-bp-light",
              "button-width": "w-auto",
              "button-x-margin": "mx-auto",
              "center-button": "mb-6",
              "button-type": "back",
              "custom-css": "disabled:opacity-50 "
            }, null, 8, ["onClick", "button-text"]))
          : _createCommentVNode("", true)
    ])
  ], 64))
})